import { render } from "./SediaAda.vue?vue&type=template&id=56b71ab5"
import script from "./SediaAda.vue?vue&type=script&lang=js"
export * from "./SediaAda.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__